import { render } from "./index.vue?vue&type=template&id=59adc80b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=59adc80b&lang=css"

import exportComponent from "D:\\site\\online-photo\\watermark-remover-spa\\tipard.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__